import { Controller } from "@hotwired/stimulus"
import { applyTheme } from "../utils/theme_transition"

// Applique le thème sans reload, avec animation circulaire (View Transition API).
// Connects to data-controller="user-settings"
export default class extends Controller {
  static values = { theme: String }

  connect() {
    applyTheme(this.themeValue || document.body.getAttribute("data-bs-theme"))
    this.element.remove()
  }
}
